import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';

import moment from 'moment';

import Aux from '../../../hoc/Auxiliary';
import BackDrop from '../../../components/UI/Backdrop/Backdrop';
import PopupBox from '../../../components/UI/PopupBox/PopupBox';
import Input from '../../../components/UI/Input/Input';
import Button from '../../../components/UI/Button/Button';

class AddResourceEvent extends Component {
    state = {
        popupOpen: true,
        addForm: {
            title: {
                label: 'Title of Event',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Title of Event'
                },
                value: 'USERNAME'
            },
            start: {
                label: "Start Time",
                elementType: 'datetime',
                elementConfig: {
                    disableClock: true
                },
                value: this.props.start
            },
            end: {
                label: "End Time",
                elementType: 'datetime',
                elementConfig: {
                    disableClock: true
                },
                value: this.props.end
            },
            resourceId: {
                label: "Resource",
                elementType: 'select',
                elementConfig: {
                    options: [
                        { value: -1, displayValue: 'No Tools Available' }
                    ]
                },
                value: -1
            }
        }
    }

    componentDidMount () {
        window.scrollTo( 0, 0 );
        const updatedForm = { ...this.state.addForm };
        const options = [];
        for( let i = 1; i < this.props.resources.length; i++ ) {
            if( this.props.permissions.some( key => key === this.props.resources[ i ].key ) ) {
                options.push( {
                    value: this.props.resources[ i ].id,
                    key: this.props.resources[ i ].key,
                    displayValue: this.props.resources[ i ].title
                } );
            }
        }
        if( options.length > 0 ) {
            const updatedResourceId = { ...updatedForm.resourceId };
            updatedResourceId.elementConfig.options = options;
            if( options.some( item => item.value === this.props.resourceId ) ) updatedResourceId.value = this.props.resourceId;
            else updatedResourceId.value = options[ 0 ].value;
            updatedForm.resourceId = updatedResourceId;
        }
        const updatedName = { ...updatedForm.title };
        updatedName.value = this.props.userName;
        updatedForm.title = updatedName;
        if( this.props.eventInfo ) {
            const updatedTitle = { ...updatedForm.title };
            updatedTitle.value = this.props.eventInfo.title;
            updatedForm.title = updatedTitle;
        }
        this.setState( { addForm: updatedForm } );
    }

    inputChangedHandler = ( event, inputId ) => {
        const updatedForm = { ...this.state.addForm };
        const updatedElement = { ...updatedForm[ inputId ] };
        updatedElement.value = event.target.value;
        updatedForm[ inputId ] = updatedElement;
        this.setState( { addForm: updatedForm } );
    }

    dateTimeHandler = ( event, inputId ) => {
        console.log( event );
        const updatedForm = { ...this.state.addForm };
        const updatedElement = { ...updatedForm[ inputId ] };
        updatedElement.value = event;
        updatedForm[ inputId ] = updatedElement;
        this.setState( { addForm: updatedForm } );
    }

    checkBooked = () => {
        const openTime = this.props.openTime;
        const closeTime = this.props.closeTime + 12;
        const startTime = moment( this.state.addForm.start.value );
        const endTime = moment( this.state.addForm.end.value );
        let eventExists = false;
        this.props.allEvents.forEach( elem => {
            //If the resources overlap or if the current event is in lab closed
            if( parseInt( this.state.addForm.resourceId.value ) === elem.group || elem.group === 0 ) {
                if( startTime.isBetween( elem.start_time, elem.end_time ) ||
                    endTime.isBetween( elem.start_time, elem.end_time ) ) {
                    eventExists = true;
                }
            } else if( ( startTime.day() === 0 || startTime.day() === 6 ) || ( endTime.day() === 0 || endTime.day() === 6 ) ) {
                eventExists = true;
            } else if( ( startTime.hour() < openTime || startTime.hour() > closeTime ) ||
                ( endTime.hour() < openTime || endTime.hour() > closeTime ) ) {
                eventExists = true;
            } else if( startTime.valueOf() >= endTime.valueOf() ) {
                eventExists = true;
            } else if( startTime.day() !== endTime.day() ) {
                eventExists = true;
            } else if( startTime.valueOf() >= moment().add( 4, 'weeks' ).valueOf() ) {
                eventExists = true;
            }

        } );
        return eventExists;
    }

    submitHandler = ( evt ) => {
        evt.preventDefault();
        if( !this.checkBooked() ) {
            const event = {
                title: this.state.addForm.title.value,
                startTime: this.state.addForm.start.value,
                endTime: this.state.addForm.end.value,
                resource: this.props.resources[ parseInt( this.state.addForm.resourceId.value ) ].key,
                user: this.props.currentId
            };
            this.props.onEventAdded( event );
            this.props.close();
        } else {
            this.props.setMessage( 'This booking time isn\'t available', 'error' );
        }
    }

    render () {
        const formElementArray = [];
        for( let key in this.state.addForm ) {
            formElementArray.push( {
                id: key,
                config: this.state.addForm[ key ]
            } );
        }
        let form = ( <Aux>
            {
                formElementArray.map( formElement => (
                    <Input
                        changed={( event ) => this.inputChangedHandler( event, formElement.id )}
                        dateTimeChanged={( event ) => this.dateTimeHandler( event, formElement.id )}
                        key={formElement.id}
                        elementId={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        label={formElement.config.label}
                    />
                ) )
            }
        </Aux> );
        return (
            <Aux>
                <BackDrop show={this.state.popupOpen} clicked={this.props.close} />
                <PopupBox>
                    <form onSubmit={this.submitHandler}>
                        {form}
                        <Button clicked={this.props.close}>CLOSE</Button>
                        <Button clicked={this.submitHandler}>ADD EVENT</Button>
                    </form>
                </PopupBox>
            </Aux >
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setMessage: ( message, style ) => dispatch( actions.setMessages( message, style ) ),
    }
}

const mapStateToProps = state => {
    return {
    }
}
export default connect( mapStateToProps, mapDispatchToProps )( AddResourceEvent );